import { Menu, MenuProps } from 'antd';
import { ComponentType } from 'react';
import styled from 'styled-components';

export const StyledItemLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  .action {
    margin-inline: 8px;
    display: flex;
    align-items: center;
  }
`;

export const StyledNavigationMenu = styled(Menu as ComponentType<any>)<MenuProps>`
  /* root padding */
  &.ant-menu .ant-menu-root {
    padding: 4px;
  }

  /* no right border on inline / vertical light mode */
  &.ant-menu-light.ant-menu-root.ant-menu-inline,
  &.ant-menu-light.ant-menu-root.ant-menu-vertical {
    border-inline-end: none;
  }

  /* inline items full width */
  &.ant-menu-light.ant-menu-inline .ant-menu-item {
    width: 100%;
    min-height: 48px;
    margin-inline: 0;
  }

  /* nested submenu titles on inline */
  &.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
    margin: 0;
    padding-inline: 0;
    padding-left: 6px !important;
  }

  /* clear background on deeper inline submenus */
  &.ant-menu-light.ant-menu-inline .ant-menu-sub.ant-menu-inline {
    background: transparent;
  }

  /* padding for sub‑items */
  &.ant-menu.ant-menu-sub.ant-menu-inline .ant-menu-item {
    padding-left: 30px !important;
  }

  /* submenu arrow base */
  &.ant-menu .ant-menu-submenu-arrow {
    inset-inline-end: 12px; /* position arrow 12px from the right */
    font-size: 16px;
    color: ${props => props.theme.colors.secondary.main.icon};
  }

  /* hover & selected backgrounds */
  && .ant-menu-item:not(.ant-menu-item-selected):hover,
  .ant-menu-submenu-title:hover {
    background: ${props => props.theme.colors.primary.light.linearHover};
  }

  .ant-menu-submenu.ant-menu-submenu-inline.ant-menu-submenu-open.ant-menu-submenu-selected {
    background: ${props => props.theme.colors.primary.light.linearHover};
  }

  /* selected item bg & text/icon color */
  .ant-menu-item.ant-menu-item-selected {
    background-color: ${props => props.theme.colors.primary.main.filled};
  }
  .ant-menu-item.ant-menu-item-selected .ant-menu-item-icon,
  .ant-menu-item.ant-menu-item-selected .ant-menu-title-content {
    color: ${props => props.theme.colors.primary.main.text};
  }

  /* make your right‑hand action icon white when selected */
  && .ant-menu-item.ant-menu-item-selected .action svg {
    color: ${props => props.theme.colors.primary.main.text} !important;
    fill: ${props => props.theme.colors.primary.main.text} !important;
  }

  /* and if you ever use an action icon on the submenu title */
  && .ant-menu-submenu-title.ant-menu-submenu-open .action svg,
  && .ant-menu-submenu-title.ant-menu-submenu-active .action svg {
    color: ${props => props.theme.colors.primary.main.text} !important;
    fill: ${props => props.theme.colors.primary.main.text} !important;
  }

  /* turn the parent label & icon blue when its submenu is open */
  &&
    .ant-menu-submenu-inline.ant-menu-submenu-open
    > .ant-menu-submenu-title
    .ant-menu-title-content {
    color: ${props => props.theme.colors.primary.main.filled} !important;
  }
  && .ant-menu-submenu-inline.ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-item-icon {
    color: ${props => props.theme.colors.primary.main.filled} !important;
    fill: ${props => props.theme.colors.primary.main.filled} !important;
  }

  /* force every item / title to full width */
  .ant-menu-inline .ant-menu-item,
  .ant-menu-inline .ant-menu-submenu-title,
  .ant-menu-item.ant-menu-item-selected {
    width: 100%;
  }

  /* padding around every menu cell */
  .ant-menu-submenu,
  .ant-menu-item {
    padding: 4px 10px;
  }

  /* submenu‑title hover removal */
  .ant-menu-submenu-title:hover {
    background-color: ${props => props.theme.colors.primary.light.linearHover} !important;
  }

  /* content typography */
  .ant-menu-title-content {
    font-size: 16px;
    line-height: 24px;
    color: ${props => props.theme.colors.secondary.main.text};
  }

  .ant-menu-item {
    padding-left: 16px !important;
  }

  .ant-menu-item-only-child {
    padding-left: 30px !important;
  }
`;

export const StyleNavigationMenuWrapper = styled.div`
  width: 260px;
  background: ${props => props.theme.colors.neutral.light.contentBg};
  border-radius: 4px;
  padding: 8px;
  box-shadow: 0 0 0 8px ${props => props.theme.colors.neutral.light.surfaceBg};
  overflow: hidden;
`;

export const StyleNavigationMenuHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0 12px 16px;
  font-size: 12px;
  font-weight: 500;
  color: ${props => props.theme.colors.neutral.main.text};
`;
